
import "./Chart";
import "../widget/Widget";
import { modules } from "../../data/ControlledLists";
import { useEffect, useState } from "react";
//import { LicenceTypes } from "../../data/ControlledLists";
import { flexTemplates } from "../../data/ControlledLists";
import { formatRFC3339 } from "date-fns";

import { BarChart, CartesianGrid, XAxis, YAxis,Tooltip,Legend, Bar} from "recharts";
import { ro } from "date-fns/locale";
const LicencePerFlexTypeChart = ({rows, handleOnGraphClick}) =>{
    const [data, setData] = useState([]);

    useEffect(() => {
        if (!rows || rows.length === 0) return;
        //console.log( rows);
    
        // Extract unique flex template names
        const uniqueTemplates = [...new Set(
            rows
                .filter(row => row.name === "kinetisense-flex" && row.displayName) // Ensure relevant rows
                .map(row => row.displayName.trim()) // Extract names
        )];
    
        let arr = uniqueTemplates.map(template => {
            const filtered = rows.filter(row => row.name === "kinetisense-flex" && row.displayName === template && row.expirationDate > formatRFC3339(new Date())
            );
            
            //const flexLicenseView = template.replace(/\s/g, "_").replace(/Kinetisense_/g, "");

            return {
                module: template.replace(/\s/g, "_").replace(/Kinetisense_/g, ""),
                original: template, // Avoid word breaking
                amount: filtered.length
            };
        });
    
        setData(arr);
    }, [rows]);
    
    const filterRows = (rows) => {
        var date = new Date();
        var date1 = date.toISOString().split("T")[0];
        console.log("date1: ", date1.split("T")[0]);
        return rows.filter((row) => row.expirationDate > date.toISOString().split("T")[0]);
    }

    const handleOnClick = (e) => {
        const clickedTemplate = data.find(d => d.module === e.activeLabel).original; // search edited display modual to find correct origin
        
        const filtered = rows.filter(row => row.displayName === clickedTemplate && row.expirationDate > formatRFC3339(new Date()));
        filterRows(rows);
        handleOnGraphClick(filtered,"for type: "+e.activeLabel);

    }
  
    return( 
        <div className="chart">
            <div className="left" >
            <center className="title">Licence Per Flex Template</center>
                <BarChart width={450} height={500} data={data} layout="vertical" margin={{ top: 5, right: 0, left: 100, bottom: 5  }} onClick={bob => handleOnClick(bob)}>
                    <CartesianGrid strokeDasharray="1 1" horizontal={false} stroke="gray" />
                    <XAxis  type="number"/>
                    <YAxis type="category" dataKey="module" interval={0} />
                    <Tooltip />
                    <Legend  />
                    <Bar dataKey="amount" fill= "#009ce0"/>
                </BarChart>
            </div>
      </div>
    )
};

export default LicencePerFlexTypeChart;